module.exports = __webpack_public_path__ + "static/samsung-logo-349c5540712dd2c353c2342a0635c1e7.svg";